module.exports = __webpack_public_path__ + "static/media/blockly-1.bb62e3c5.png";